import React from 'react'
import { Input } from '../../../../UI/InputElement/reactFormHookInputField'
import withFormHoc from '../../../../../../hoc/withReactHookForm/withReactHookForm'
import { useFieldArray } from 'react-hook-form'
import NewDailyKittingSection from './NewDailyKittingSection'
import { useSelector } from 'react-redux'
import AssetsFormSkeleton from '../../../../Inventory/Assets/NewAssetsForm/AssetsFormSkeleton'

function NewDailyKIttingPage(props) {
  const { fields, append, remove } = useFieldArray({ control: props.control, name: "sections" })
  const { isLoading,isUpdateDailykitting } = useSelector((state) => state.InventoryModuleReducer)
  const defaultTaskData = {
   
  }

  const ValidateHours=(value)=>{
    if(+value >=1 && +value <=24 ){
     return true
    }
    return "Hours must be between one to twenty four"
 }

  const addTaskToList = (e) => {
    e.preventDefault();
    append(defaultTaskData)
  }

  const removeFromTaskList = (index) => (e) => {
    e.preventDefault();
    remove(index)
  }

  if(isUpdateDailykitting){
    return <AssetsFormSkeleton />
  }

  return (
    <main class="app-content wraper_content chart_section">
      <section class="teammanage_formmain">
        <div class="container">
          <div class="row" >
            <div class="col-lg-12">
              <div class="team_manage_head">
                <h1 class="tm_top_head">Daily Kitting: Safety Log</h1>
              </div>
            </div>
            <form class="col-lg-12" noValidate onSubmit={props.handleSubmit((data) => {
              props.onSubmit(data)
            })}>
              <div class="tm_form_wrapper">
                <div class="tm_form_wrap">
                  <div class="tm_form_innner">
                    <div class="form">
                      <div class="row">
                        <div class="col-md-6 col-sm-12">
                          <div class="form-group mb-0">
                            {/* <label for="jobname" class="form-label"
                          >Location</label>
                          <input
                            type="text"
                            class="form-control"
                            id="jobname"
                            aria-describedby=""
                            placeholder="Type here"
                          /> */}


                            <Input
                              type="text"
                              id={`location`}
                              name={`location`}
                              formControlClasses="form-control"
                              placeholder="Location"
                              required
                              label="Location"
                              formControlProps={props.register(`location`, {
                                required: "This field is required",
                                // pattern: {
                                //   value:/^[0-9]*$/ ,
                                //   message:"Must Be a number"
                                // },
                                maxLength: 80,
                              })}
                              validationErrorMessage={
                                props.errors?.location?.message ?? ""
                              }
                              disabled={props?.isView}
                            />

                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <div class="form-group">
                            {/* <label for="jobname" class="form-label">Shift</label>
                          <input
                            type="date"
                            class="form-control"
                            id="jobname"
                            aria-describedby=""
                            placeholder="Location"
                          /> */}
                            <Input
                              type="number"
                              id={`shift_time`}
                              name={`shift_time`}
                              formControlClasses="form-control"
                              placeholder="Shift" 
                              required
                              label="Shift"
                              formControlProps={props.register(`shift_time`, {
                                required: "This field is required",
                                validate:ValidateHours,
                                // pattern: {
                                //   value:/^[0-9]*$/ ,
                                //   message:"Must Be a number"
                                // },
                                maxLength: 80,
                              })}
                              validationErrorMessage={
                                props.errors?.shift_time?.message ?? ""
                              }
                              disabled={props?.isView}
                              isIcon={true}
                            />
                            {/* <div class="calendar_icon">
                              <img
                                src="/images/icons/reminder.svg"
                                alt="calendar"
                              />
                            </div> */}
                          </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                          <div class="form-group">
                            {/* <label for="jobname" class="form-label">Month</label>
                          <input
                            type="date"
                            class="form-control"
                            id="jobname"
                            aria-describedby=""
                            placeholder="Location"
                          /> */}

                            <Input
                              type="date"
                              //datePickerType="month"
                              formControlClasses="form-control"
                              id={`date`}
                              placeholder="MM/DD/YYYY"
                              control={props.control}
                              controller={props.controller}
                              selectName={`date`}
                              dateFormat="MM/dd/yyyy"
                              // minDate={new Date().setDate(current.getDate() - 400)}
                              preventReadOnly={false}
                              label="Date"
                              formControlProps={props.register(`date`, {
                                required: "This field is required",
                                //   validate:handleValidateDateCompleted
                              })}
                              validationErrorMessage={props.errors?.date?.message ?? ""}
                              disabled={props?.isView}
                            />

                            {/* <div class="calendar_icon">
                            <img
                              src="images/icons/calendar.svg"
                              alt="calendar"
                            />
                          </div> */}
                          </div>
                        </div>
                        {/* <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="jobname" class="form-label">Year</label>
                          <input
                            type="date"
                            class="form-control"
                            id="jobname"
                            aria-describedby=""
                            placeholder="Location"
                          />
                          <div class="calendar_icon">
                            <img
                              src="images/icons/calendar.svg"
                              alt="calendar"
                            />
                          </div>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {
                  fields?.map((field, index) => (
                    <NewDailyKittingSection setValue={props?.setValue} setFocus={props.setFocus} isView={props?.isView} key={index} controller={props.controller} field={field} control={props.control} index={index} register={props.register} errors={props.errors} removeFromTaskList={removeFromTaskList} getValues={props.getValues} />
                  ))
                }
                {
                  !props?.isEdit && !props?.isView ? <div class="action_button" >
                    <span onClick={addTaskToList}>+ Add More</span>
                  </div> : null
                }

                {/* <div class="tm_form_wrap">
                <div class="tm_form_innner">
                  <div class="form">
                    <div class="row">
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Specialist</label>
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Item</label
                          >
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group mb-0">
                          <label for="jobname" class="form-label">Count</label>
                          <input
                            type="text"
                            class="form-control"
                            id="jobname"
                            aria-describedby=""
                            placeholder="Type here"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12">
                        <div class="action_button">
                          <a href="javascript:void(0)">+ Add More</a>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12">
                        <span class="selectdays_numb">
                          <span class="addmore_days">
                            <div class="form-group mb-0" style={{"width": "68px"}}>
                              <label for="disabledSelect" class="form-label"
                              >Day</label
                              >
                              <select id="disabledSelect" class="form-select">
                                <option>00</option>
                                <option>01</option>
                                <option>02</option>
                                <option>03</option>
                                <option>04</option>
                              </select>
                              <div class="dropdown_caret">
                                <img
                                  src="images/icons/dropdown_caret.svg"
                                  alt="dropdown_caret"
                                />
                              </div>
                            </div>
                            <div
                              class="form-group mb-0"
                              style={{"width": "38px", marginLeft: "10px"}}
                            >
                              <label
                                for="disabledSelect"
                                class="form-label invisible"
                              >numb</label>
                              <input
                                type="text"
                                class="form-control"
                                id="jobname"
                                aria-describedby=""
                                placeholder="00"
                              />
                            </div>
                            <div
                              class="action_button"
                              style={{marginTop: "23px", marginLeft: "22px"}}
                            >
                              <a href="javascript:void(0)" class="mb-0"
                              >+ Add More</a
                              >
                            </div>
                          </span>
                          <span class="daysnumb_input">
                            <div class="form-group">
                              <span class="mixed_label">
                                <label for="disabledSelect" class="form-label"
                                >Days</label>
                                <label for="disabledSelect" class="form-label"
                                >Number</label>
                              </span>
                              <span class="inputadded_numb active">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                              </span>
                              <span class="inputadded_numb">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                              </span>
                              <span class="inputadded_numb">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                />
                              </span>
                            </div>
                          </span>
                        </span>
                        <span>
                          <div class="form-group">
                            <div class="totaldays_numb">
                              <label class="form-label">Total</label>
                              <span>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="jobname"
                                  aria-describedby=""
                                  placeholder="00"
                                  style={{width:'158px'}}
                                />
                              </span>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
                {/* <div class="tm_form_wrap">
                <div class="tm_form_innner">
                  <div class="form">
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Specialist Codes</label
                          >
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Solution Codes</label
                          >
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Filter Codes</label>
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="disabledSelect" class="form-label"
                          >Misc. Item Codes</label
                          >
                          <select id="disabledSelect" class="form-select">
                            <option>Please Select</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select>
                          <div class="dropdown_caret">
                            <img
                              src="images/icons/dropdown_caret.svg"
                              alt="dropdown_caret"
                            />
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div> */}

                <div class="col-md-12 col-sm-12">
                  <div class="form-group">
                    {/* <label for="floatingTextarea">Comments</label>
                    <textarea
                      class="form-control"
                      placeholder="Type here"
                      id="floatingTextarea"
                    ></textarea> */}

                          <Input
                              type="textarea"
                              id={`comments`}
                              name={`comments`}
                              formControlClasses="form-control"
                              placeholder="Type here"
                              required
                              label="Comments"
                              formControlProps={props.register(`comments`, {
                                required: "This field is required",
                                // pattern: {
                                //   value:/^[0-9]*$/ ,
                                //   message:"Must Be a number"
                                // },
                                maxLength: 80,
                              })}
                              validationErrorMessage={
                                props.errors?.comments?.message ?? ""
                              }
                              disabled={props?.isView}
                            />
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <div class="submitcancel_btn">
                      <button type="button" class="btn cst_btn btn-outline-secondary  cancel_btnnew" onClick={props?.resetForm}>
                        Cancel
                      </button>

                      {
                        !props?.isView ? <button type="submit" className={isLoading ? "btn cst_btn btn_danger btn-wait" : "btn cst_btn btn_danger"}>
                          {isLoading ? "" : props.isEdit ? "Update" : "Submit"}
                        </button> : null
                      }

                      {/* <button type="button" class="btn theme_def_btn1">
                      Submit
                    </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div >
        </div>
      </section>
    </main>
  )
}

export default withFormHoc(NewDailyKIttingPage)


